import React, { useEffect, useState } from 'react';
import TimelineContext from './TimelineContext';

const useTimeline = () => {
    const timelineContext = React.useContext(TimelineContext);
    const [ rerender, setRerender ] = useState(0);

    useEffect(() => {
        setRerender(rerender + 1);
    }, [timelineContext.ratio, timelineContext.timelineValue, timelineContext.activeLine, timelineContext.activeBlock, timelineContext.hoverLine]);

    return timelineContext;
};

export default useTimeline;
